<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005eff"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="#FDAC53" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-form>
      <v-layout wrap>
        <v-flex xs12 py-3>
          <v-switch @change="validate(storage.WorkTimeSwitch)" v-model="storage.WorkTimeSwitch" label="Is All Time"> </v-switch>
        </v-flex>
        <v-flex xs12 sm6>
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="storage.startingTime"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
              :disabled ="storage.WorkTimeSwitch"
              :rules="[rules.required]"
                v-model="storage.startingTime"
                label="Starting Time"
                prepend-icon="mdi-clock"
                dense
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="menu1"
              v-model="storage.startingTime"
              full-width
              @click:minute="$refs.menu1.save(storage.startingTime)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm6>
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="storage.endingTime"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
               :disabled ="storage.WorkTimeSwitch"
                v-model="storage.endingTime"
                  :rules="[rules.required]"
                prepend-icon="mdi-clock"
                label="Ending Time"
                dense
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="menu2"
              v-model="storage.endingTime"
              full-width
              @click:minute="$refs.menu2.save(storage.endingTime)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 py-4 text-center>
          <v-btn dark block color="#FEBD08" @click="edit()"> SAVE </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>
<script>
import axios from "axios";

export default {
  props:["storage"],
  data() {
    return {
      appLoading: false,
      showsnackbar: false,
      msg: null,
      WorkTimeSwitch: false,
      startingTime: null,
      endingTime: null,
      menu1: false,
      menu2: false,
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        num: (value) => (value < 100 && value >= 0) || "Must be between 0-100",
      },
    };
  },


mounted()
{
  console.log(this.storage,"/////")
},

methods:{




  validate(value)
  {

    if(value == true)
    {
      this.storage.startingTime = "00:00";
      this.storage.endingTime = "00:00";
    }

  },



edit() {
         
        let getURL;
        getURL = "/grocery/admin/seller/edit";
        axios({
          method: "POST",
          url: getURL,
          data: {
            isAlltimeDeliveryAvailable: this.storage.WorkTimeSwitch,
            deliveryTimeFrom: this.storage.startingTime,
            deliveryTimeTo: this.storage.endingTime,
            uid:this.storage.uid
          },
          headers: {
            token: localStorage.getItem("token"),
          },
        }).then((response) => {
          if (response.data.status == true) {
            this.$emit("stepper", {
              getData: true,
            });
            this.msg = " Working Schedule Time Updated Successfully";
            this.showsnackbar = true;
          } else {
            this.show = false;
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        });
      },
}
};
</script>

